<div class="snackbar-wrapper">
  <mat-icon class='material-icons-outlined mat-icon mat-icon-no-color snackbar-icon {{iconClass}}'>{{icon}}</mat-icon>
  <span class="snackbar-text">{{ message | translate}}</span>
  <div class="flex-grow"></div>
  <button mat-button class="snackbar-action-dismiss" (click)="snackBarRef.dismiss()" *ngIf="isAction">{{ actionText | translate}}</button>
</div>
